import IClient from "@interfaces/Core/ClientManager/client";
import useApiCall from "@hooks/Shared/useApiCall";

const useGetClient = (uuid: string) =>
  useApiCall<IClient>({
    url: `/clients/${uuid}`,
  });

export default useGetClient;
